import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactCalendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import LeftArrowIcon from './LeftArrowIcon';
import RightArrowIcon from './RightArrowIcon';

const StyledCalendar = styled(ReactCalendar)`
  border: none;

  .react-calendar__month-view .react-calendar__tile {
    margin: 4px 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    position: relative;
  }

  .react-calendar__month-view .react-calendar__tile--now abbr {
    background: #eaefff;
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 16px 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus,
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background: none;
  }

  .react-calendar__tile:disabled,
  .react-calendar__tile:disabled > * {
    background: none;
    color: #757575;
    opacity: 0.8;
  }

  .react-calendar__tile > *,
  .react-calendar__navigation button {
    font-weight: 600;
    font-size: 14px;
    color: ${props => props.theme.text.normal};
    background: none;
  }

  .react-calendar__tile--hasActive {
    background: none;
  }

  .react-calendar__month-view .react-calendar__tile > * {
    width: 31px;
    height: 31px;
    max-width: 31px !important;
    max-height: 31px !important;
    border-radius: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .react-calendar__month-view .react-calendar__tile--active > * {
    background-color: #eaefff;
  }

  .react-calendar__month-view__weekdays {
    margin-bottom: 5px;
  }

  .react-calendar__month-view .react-calendar__tile:hover > * {
    background-color: ${props => props.theme.primary.normal};
    color: #ffffff;
  }

  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
    font-weight: bold;
    font-size: 10px;
    text-align: center;
    display: block;
    text-transform: uppercase;
  }

  .react-calendar__navigation__prev2-button,
  .react-calendar__navigation__next2-button {
    display: none !important;
  }

  .react-calendar__navigation {
    border-radius: 22px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #ececec;
    display: flex;
    height: 44px;
    margin-bottom: 15px;
  }

  .react-calendar__navigation i {
    position: relative;
    top: 2px;
  }

  .react-calendar__navigation button {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    min-width: 44px;
  }

  .react-calendar__navigation button[disabled] {
    background: none;
    color: #757575;
    opacity: 0.8;
  }

  .react-calendar__month-view .react-calendar__tile--hover,
  .react-calendar__month-view
    .react-calendar__tile--range:not(
      .react-calendar__tile--rangeEnd,
      .react-calendar__tile--rangeStart
    ) {
    background: #eaefff;
  }

  .react-calendar__month-view abbr {
    position: relative;
    z-index: 2;
  }

  .react-calendar__month-view
    .react-calendar__tile--hoverStart:not(
      .react-calendar__tile--hoverBothEnds
    ) {
    background: none;
  }

  .react-calendar__month-view
    .react-calendar__tile--hoverStart:not(
      .react-calendar__tile--hoverBothEnds
    ):before,
  .react-calendar__tile--rangeStart:not(
      .react-calendar__tile--rangeBothEnds
    ):before {
    content: '';
    background: #eaefff !important;
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    right: 0;
  }

  .react-calendar__month-view
    .react-calendar__tile--hoverEnd:not(
      .react-calendar__tile--hoverBothEnds
    ):before,
  .react-calendar__tile--rangeEnd:not(
      .react-calendar__tile--rangeBothEnds
    ):before {
    content: '';
    background: #eaefff !important;
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .react-calendar__month-view
    .react-calendar__tile--hoverEnd:not(
      .react-calendar__tile--hoverBothEnds
    ):after {
    background: #eaefff !important;
    border-top-right-radius: 100%;
    border-bottom-right-radius: 100%;
  }

  .react-calendar__month-view .react-calendar__tile--rangeStart abbr,
  .react-calendar__month-view .react-calendar__tile--rangeEnd abbr {
    background: #285aff;
    color: white;
  }
`;

const Calendar = ({ onDateSelect, ...props }) => {
  return (
    <StyledCalendar
      {...props}
      prevLabel={<LeftArrowIcon />}
      nextLabel={<RightArrowIcon />}
      onChange={onDateSelect}
      className="Calendar__root"
    />
  );
};

Calendar.propTypes = {
  onDateSelect: PropTypes.func,
};

Calendar.defaultProps = {
  onDateSelect: () => {},
};

export default Calendar;
